export default "__VITE_ASSET__AISppr85__"